import type { CSSProperties, ReactNode } from "react";
import type { GroupColors } from "../../../../datagrid/ColumnVisibilityModal";
import { getContrastTextColor } from "../../../../datagrid/colorGradingUtils";

export function resolveGroupColors(groupColors: GroupColors, groupName: string) {
	const groupBgColor = groupColors[groupName];
	const groupTextColor = groupBgColor ? getContrastTextColor(groupBgColor) : undefined;
	return { groupBgColor, groupTextColor };
}

export function groupColorStyle(
	groupBgColor?: string,
	groupTextColor?: string,
): CSSProperties | undefined {
	if (!groupBgColor) {
		return undefined;
	}
	return { backgroundColor: groupBgColor, color: groupTextColor };
}

export function withGroupColoredHeaderClass(baseClassName: string, groupBgColor?: string): string {
	if (!groupBgColor) {
		return baseClassName;
	}
	if (!baseClassName) {
		return "discoverGamesTableV3-coloredHeader";
	}
	return `${baseClassName} discoverGamesTableV3-coloredHeader`;
}

interface GroupColorCellWrapProps {
	groupBgColor?: string;
	groupTextColor?: string;
	className?: string;
	children: ReactNode;
}

/** Applies group background/text color on the wrapper when a group color is set. */
export function GroupColorCellWrap({ groupBgColor, groupTextColor, className, children }: GroupColorCellWrapProps) {
	if (!groupBgColor) {
		return <>{children}</>;
	}

	return (
		<div
			className={["discoverGamesTableV3-coloredCell", className].filter(Boolean).join(" ")}
			style={groupColorStyle(groupBgColor, groupTextColor)}
		>
			{children}
		</div>
	);
}

interface GroupColorHeaderWrapProps {
	groupBgColor?: string;
	groupTextColor?: string;
	className?: string;
	children: ReactNode;
}

/** Header wrapper: applies group color styles; adds `discoverGamesTableV3-coloredHeader` when colored. */
export function GroupColorHeaderWrap({ groupBgColor, groupTextColor, className, children }: GroupColorHeaderWrapProps) {
	return (
		<div
			className={withGroupColoredHeaderClass(className ?? "", groupBgColor)}
			style={groupColorStyle(groupBgColor, groupTextColor)}
		>
			{children}
		</div>
	);
}
